//@*/*
//    *RPD  Appv0.91
//    * Copyright (c) 2022, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//

/* eslint-disable */
//line_cnt_by_weeks
const home = () => import("../components/home.vue");
const admin = () => import("../components/admin.vue");
const pagenoutfound = () => import("../components/pagenoutfound.vue");

export const routes = [
  { name: "home", path: "/", component: home, display: "Home", icon: "Home" },
  { name: "admin", path: "/admin", component: admin, display: "Admin" },
  // { name: "not-found", path: "/:pathMatch(.*)*", component: pagenoutfound },
];
